"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dayjs = _interopRequireDefault(require("../utils/dayjs"));
var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));
var _date = _interopRequireDefault(require("@spothero/utils/date"));
var _DatePickerCalendarNavigation = _interopRequireDefault(require("./DatePickerCalendarNavigation"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DATE = new Date();
class DatePickerCalendar extends _react.Component {
  static defaultProps = {
    selectedDate: '',
    initialMonth: DATE,
    disablePast: true,
    overrideInitialMonthWithSelected: true
  };
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: props.selectedDate
    };
    this._weekdayTitles = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  }
  _onDaySelected = (day, {
    selected,
    disabled
  }, evt) => {
    if (disabled) {
      return;
    }
    const {
      onChange
    } = this.props;
    const selectedDate = (0, _dayjs.default)(day).format('MM/DD/YYYY');
    this.setState({
      selectedDate
    });
    if (onChange) {
      onChange(selectedDate);
    }
  };
  _modifierSelected = day => {
    const {
      selectedDate
    } = this.state;
    if (!(0, _isEmpty.default)(selectedDate)) {
      return _reactDayPicker.DateUtils.isSameDay(_date.default.getAsDate(selectedDate), day);
    } else {
      return null;
    }
  };
  _modifierDisabled = day => {
    const {
      disablePast,
      disableBefore,
      disableAfter
    } = this.props;
    let isDayDisabled = false;
    let disableDay = false;
    if (disableBefore) {
      disableDay = (0, _dayjs.default)(day).isBefore(_date.default.getAsDate(disableBefore), 'day');
      isDayDisabled = disableDay;
    }
    if (disableAfter && !isDayDisabled) {
      disableDay = (0, _dayjs.default)(day).isAfter((0, _dayjs.default)(_date.default.getAsDate(disableAfter)), 'day');
      isDayDisabled = disableDay;
    }
    if (disablePast && !isDayDisabled) {
      disableDay = _reactDayPicker.DateUtils.isPastDay(day);
    }
    return disableDay;
  };
  _renderDayMarkup = day => {
    const m = (0, _dayjs.default)(day);
    const date = `${m.format('MM')}/${m.format('DD')}/${m.format('YYYY')}`;
    return /*#__PURE__*/_react.default.createElement("span", {
      "data-date": date
    }, day.getDate());
  };
  render() {
    const {
      className,
      initialMonth,
      disablePast,
      disableBefore,
      disableAfter,
      overrideInitialMonthWithSelected
    } = this.props;
    const {
      selectedDate
    } = this.state;
    const classes = (0, _classnames.default)('DatePicker-calendar', className);
    let firstMonth = initialMonth;
    let fromMonth = disablePast ? DATE : null;
    let toMonth = null;
    if (disableBefore) {
      const beforeDate = _date.default.getAsDate(disableBefore);
      if (fromMonth) {
        if ((0, _dayjs.default)(beforeDate).isAfter((0, _dayjs.default)(fromMonth))) {
          fromMonth = beforeDate;
        }
      } else {
        fromMonth = beforeDate;
      }
      firstMonth = fromMonth;
    }
    if (disableAfter) {
      toMonth = _date.default.getAsDate(disableAfter);
    }
    if (selectedDate && overrideInitialMonthWithSelected) {
      firstMonth = _date.default.getAsDate(selectedDate);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, {
      selectedDays: this._modifierSelected,
      disabledDays: this._modifierDisabled,
      onDayClick: this._onDaySelected,
      fromMonth: fromMonth,
      toMonth: toMonth,
      initialMonth: firstMonth,
      renderDay: this._renderDayMarkup,
      weekdaysShort: this._weekdayTitles,
      navbarElement: /*#__PURE__*/_react.default.createElement(_DatePickerCalendarNavigation.default, null),
      showOutsideDays: true
    }));
  }
}
exports.default = DatePickerCalendar;